import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { vehicle_type_option } from "../../utilities";
import {
  createVehicleApi,
  updateVehicleApi,
} from "../../services/VehicleService";
import Select from "react-select";
import { getBrandModelApi } from "../../services/SearchService";
const AddVehicleModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const [modelOption, setmodelOption] = useState([]);
  const [selectedModel, setSelecetdModel] = useState(null);
  const [form, setForm] = useState({
    customer_name: "",
    customer_contact: "",
    vehicle_number: "",
    vehicle_model_id: "",
  });
  const [error, setError] = useState({});
  const getBrandModel = (id) => {
    getBrandModelApi()
      .then((res) => {
        const apiData = res?.data?.results || [];
        const modelList = apiData.flatMap((b) =>
          b.models.map((m) => ({
            label: `${m.label} [${b.label}]`,
            value: m.value,
            brandId: b.value,
            brandLabel: b.label,
            searchLabel: `${b.label} ${m.label}`.toLowerCase(),
          }))
        );

        setmodelOption(modelList);
        setSelecetdModel(modelList?.find((item) => item?.value == id) || null);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (visible) {
      getBrandModel(data?.vehicle_model?.id);
      handleReset();
    }
  }, [visible]);

  useEffect(() => {
    setForm({
      ...form,
      vehicle_model_id: selectedModel?.value || "",
    });
    if (error?.vehicle_model_id && selectedModel?.value) {
      setError({ ...error, vehicle_model_id: "" });
    }
  }, [selectedModel]);

  const handleReset = () => {
    if (data) {
      setForm({
        ...form,
        customer_name: data?.customer_name || "",
        customer_contact: data?.customer_contact || "",
        vehicle_number: data?.vehicle_number || "",
      });
    } else {
      setForm({
        customer_name: "",
        customer_contact: "",
        vehicle_number: "",
        vehicle_model_id: "",
      });
      setSelecetdModel(null);
    }

    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "customer_contact") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));

      if (numericValue.length === 10) {
        if (error?.customer_contact) {
          setError((prev) => ({ ...prev, customer_contact: "" }));
        }
      } else {
        setError((prev) => ({
          ...prev,
          customer_contact: "Must be 10 digits",
        }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));

      if (value && error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.customer_name?.trim()) {
      error.customer_name = "Name is required";
    }
    if (!form.customer_contact?.trim()) {
      error.customer_contact = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.customer_contact)) {
      error.customer_contact = "Enter a valid 10-digit mobile number";
    }
    if (!form.vehicle_number?.trim()) {
      error.vehicle_number = "Vehicle number is required";
    }
    if (!form.vehicle_model_id?.trim()) {
      error.vehicle_model_id = "Vehicle model is required";
    }

    setError(error);
    if (Object.keys(error).length === 0) {
      if (data) {
        updateVehicle();
      } else {
        addVehicle();
      }
    }
  };

  const addVehicle = () => {
    setLoading(true);
    createVehicleApi(form)
      .then(() => {
        toast.success("Vehicle Added successfully");
        handleReset();
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const updateVehicle = () => {
    setLoading(true);
    updateVehicleApi(data?.id || "", form)
      .then(() => {
        toast.success("Vehicle update successfully");
        handleReset();
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Update Vehicle" : "Add Vehicle"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          <div className="row gx-2 mb-2">
            <div className="col">
              <label className="form-label text-dark">Vehicle Number</label>
              <input
                type="text"
                name="vehicle_number"
                className={`form-control ${
                  error?.vehicle_number ? "is-invalid" : ""
                }`}
                value={form.vehicle_number}
                placeholder="OD-21-AK-9827"
                onChange={handleInputChange}
              />
              {error?.vehicle_number && (
                <small className="text-danger">{error.vehicle_number}</small>
              )}
            </div>
            <div className="col">
              <label className="form-label text-dark">Vehicle Model</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder="Select Vehicle"
                options={modelOption}
                value={selectedModel}
                onChange={setSelecetdModel}
              />
              {error?.vehicle_model_id && (
                <small className="text-danger">{error?.vehicle_model_id}</small>
              )}
            </div>
          </div>

          <div className="mb-2">
            <label className="form-label text-dark">Customer Name</label>
            <input
              type="text"
              name="customer_name"
              className={`form-control ${
                error?.customer_name ? "is-invalid" : ""
              }`}
              value={form.customer_name}
              placeholder="John Deo"
              onChange={handleInputChange}
            />
            {error?.customer_name && (
              <small className="text-danger">{error.customer_name}</small>
            )}
          </div>
          <div className="mb-2">
            <label className="form-label text-dark">Mobile Number</label>
            <input
              type="text"
              name="customer_contact"
              className={`form-control ${
                error?.customer_contact ? "is-invalid" : ""
              }`}
              value={form.customer_contact}
              placeholder="9777303064"
              onChange={handleInputChange}
            />
            {error?.customer_contact && (
              <small className="text-danger">{error.customer_contact}</small>
            )}
          </div>

          <code className="text-light">
            <strong>Note:</strong> All fields are required. Please enter a valid
            Vehicle Number.
          </code>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />}
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddVehicleModal;
